// PWA — install prompt & service worker
export const PWA = {
  INSTALL_BUTTON: "pwa-install-button",
};
